import TabbedPage from "src/components/TabbedPage";

import AdminSendEmailForm from "src/components/dashboard/admin/emails/AdminSendEmailForm";
import EmailTemplates from "src/components/dashboard/admin/emails/EmailTemplates";
import EmailSignature from "../components/dashboard/admin/emails/Signature";
import { useTranslation } from "react-i18next";

const Emails = () => {
    const { t } = useTranslation();
    return (
        <TabbedPage dialog={true}>
            <AdminSendEmailForm label={t('Emails.tabbedPages.sendEmail')} />
            <EmailTemplates label={t('Emails.tabbedPages.templates')} />
            <EmailSignature label={t('Emails.tabbedPages.signature')} />
        </TabbedPage>
    );
};
export default Emails;
